export const TERRITORYFILTER_REQUEST = 'TERRITORYFILTER_REQUEST';
export const TERRITORYFILTER_SUCCESS = 'TERRITORYFILTER_SUCCESS';
export const TERRITORYFILTER_FAILURE = 'TERRITORYFILTER_FAILURE';
